import { TestProps } from "../../../types";

export enum AtAlertVariant {
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
  INFO = "info",
}

export interface AtAlertProps extends TestProps {
  variant: AtAlertVariant;
  open: boolean;
  setClose?: () => void;
  showCloseButton?: boolean;
  action?: () => void;
  buttonText?: string;
  alertText: React.ReactNode;
  timeOut?: number;
  className?: string;
  autoClose?: boolean;
  buttonClassName?: string;
  backdropClose?: boolean;
}
